/**
 * Shared types for the gamification KPI primitives. Status tones mirror the
 * server-side `StatusTone` in `server/admin-handlers/adsActivityVerdict.ts`
 * so the client visual layer maps 1:1 to verdict output.
 */
export type KpiTone = "amber" | "green" | "gold" | "red" | "grey";

export type FreshAchievement = {
  id: string;
  user_id: string;
  organization_id: string;
  achievement_key: string;
  unlocked_at: string;
  metadata: Record<string, unknown>;
  revoked_at?: string | null;
};

export const KPI_TONE_CLASSES: Record<KpiTone, { fill: string; ring: string; text: string }> = {
  amber: {
    fill: "bg-kpi-warn/15 dark:bg-kpi-warn-dark/30",
    ring: "ring-kpi-warn/40 dark:ring-kpi-warn-dark/50",
    text: "text-amber-800 dark:text-amber-200",
  },
  green: {
    fill: "bg-kpi-good/15 dark:bg-kpi-good-dark/25",
    ring: "ring-kpi-good/40 dark:ring-kpi-good-dark/50",
    text: "text-emerald-800 dark:text-emerald-200",
  },
  gold: {
    fill: "bg-kpi-gold/15 dark:bg-kpi-gold-dark/25",
    ring: "ring-kpi-gold/40 dark:ring-kpi-gold-dark/50",
    text: "text-yellow-800 dark:text-yellow-200",
  },
  red: {
    fill: "bg-kpi-attn/15 dark:bg-kpi-attn-dark/30",
    ring: "ring-kpi-attn/40 dark:ring-kpi-attn-dark/50",
    text: "text-red-800 dark:text-red-200",
  },
  grey: {
    fill: "bg-gray-200/60 dark:bg-zinc-700/40",
    ring: "ring-gray-300/40 dark:ring-zinc-600/40",
    text: "text-gray-700 dark:text-gray-300",
  },
};

export const KPI_TONE_DOT_CLASS: Record<KpiTone, string> = {
  amber: "bg-kpi-warn dark:bg-kpi-warn-dark",
  green: "bg-kpi-good dark:bg-kpi-good-dark",
  gold: "bg-kpi-gold dark:bg-kpi-gold-dark",
  red: "bg-kpi-attn dark:bg-kpi-attn-dark",
  grey: "bg-gray-400 dark:bg-zinc-500",
};
